import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { BiBrush } from 'react-icons/bi';

import HintBlock from '@/components/common/HintBlock';
import { ScenarioSimpleTextInput } from '@/components/dashboard/knowledge-bases-create/scenario/text-scenario/scenario-simple-text-input';
import MarkdownHelpModal from '@/components/ui/MarkdownHelpModal';

interface BotResponseInputProps {
  title: string;
  getValues: UseFormGetValues<any>;
  name: string;
  placeholder: string;
  setValue: UseFormSetValue<any>;
  errors?: any;
  config: any;
  showCallupFunctionsButton?: boolean;
  disabled?: boolean;
  max?: number;
}

const BotResponseInput: React.FC<BotResponseInputProps> = ({
  title,
  getValues,
  name,
  placeholder,
  setValue,
  errors,
  config,
  showCallupFunctionsButton = true,
  disabled,
  max,
}) => {
  const [showMarkDownGuide, setShowMarkDownGuide] = useState(false);
  const [contextMenuList, setContextMenuList] = useState<any[]>([]);

  useEffect(() => {
    if (config?.metaData?.variables) {
      setContextMenuList([...config.metaData.variables]);
    }
  }, [config]);

  return (
    <>
      <Form.Group className="tw-w-full">
        <Form.Label className="tw-text-[#687076] tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">{title}</Form.Label>

        <ScenarioSimpleTextInput
          isMultiline
          placeholder={placeholder}
          setValue={(text: string) => setValue(name, text)}
          value={getValues(name)}
          contextMenuList={contextMenuList}
          isInvalid={!!errors?.[name]}
          showCallupFunctionsButton={showCallupFunctionsButton}
          disabled={disabled}
        />

        {errors?.[name]?.message && (
          <Form.Control.Feedback type="invalid" className="d-block font-poppins">
            {errors[name].message}
          </Form.Control.Feedback>
        )}

        <div className="tw-flex tw-justify-between tw-items-center">
          <button
            id="btn-brush"
            type="button"
            className="tw-bg-transparent tw-text-sm tw-font-normal tw-font-['Lexend'] tw-underline tw-leading-tight tw-border-none"
            onClick={() => setShowMarkDownGuide(true)}
          >
            <BiBrush className="tw-mr-2" color="blue" />
            <HintBlock texts={['Markdown/tooltips']} />
          </button>
          {max && (
            <span
              className={`tw-text-xs ${
                (getValues(name)?.length || 0) > max
                  ? 'tw-text-red-500'
                  : (getValues(name)?.length || 0) > max * 0.9
                  ? 'tw-text-orange-500'
                  : 'tw-text-gray-500'
              }`}
            >
              {getValues(name)?.length || 0}/{max}
            </span>
          )}
        </div>
      </Form.Group>
      <Modal show={showMarkDownGuide} onHide={() => setShowMarkDownGuide(false)} size="lg" centered>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <div className="tw-flex tw-justify-between tw-items-center tw-pb-4">
                <MarkdownHelpModal />
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BotResponseInput;
